module.exports = __webpack_public_path__ + "img/id.4198c694.png";